import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  PolizasService,
  queryGetPolicyList,
} from 'src/app/core/http/apiPolicy/polizas.service';
import {
  CotizacionService,
  queryGetCotizationList,
} from 'src/app/core/http/apiPricing/cotizacion.service';
import {
  ObjetosService,
  queryObjectsCotization,
} from 'src/app/core/http/apiProducto/objetos.service';
import moment from 'moment';
import { Store } from '@ngrx/store';
import {
  setQuote,
} from 'src/app/state/quotation/quotation.actions';
import { IPolicyGroupInfo } from 'src/app/core/interfaces/shared/components/IPolicyGroupInfo';
import { Router } from '@angular/router';
import { setContract } from 'src/app/state/contracts/contracts.actions';
import {
  IContractItem,
  IPolicyCompleteData,
} from 'src/app/state/contracts/contracts.models';
import { forkJoin, of, Subject } from 'rxjs';
import { first, map, switchMap, takeUntil } from 'rxjs/operators';
import { resetSelectedObject, selectObject } from 'src/app/state/objects/objects.actions';
import { CoberturasService } from 'src/app/core/http/apiProducto/coberturas.service';
import { IPolicyOrQuotation } from 'src/app/core/interfaces/shared/components/IPolicyOrQuotation';
import { ICoverage } from 'src/app/state/coverages/coverages.models';
import { selectPartner } from 'src/app/state/user/user.selectors';
import { selectSelectedObject } from 'src/app/state/objects/objects.selectors';
import { IObject } from 'src/app/state/objects/objects.models';
import { FraccionamientoService } from 'src/app/core/http/apiProducto/fraccionamiento.service';
import { setPaymentFractionState } from 'src/app/state/paymentFractions/paymentFractions.actions';

@Component({
  selector: 'app-policy-list',
  templateUrl: './policy-list.component.html',
  styleUrls: ['./policy-list.component.scss'],
})
export class PolicyListComponent implements OnInit, OnDestroy {
  policies: IContractItem[] = [];

  layout: 'inline' | 'columns' = 'columns';

  queryPolicyList: queryGetPolicyList = {};

  queryCotizationList: queryGetCotizationList = {
    IdEstadoCotizacion: 2,
  };

  queryCoberturas: queryObjectsCotization = {};

  private unsuscribe$ = new Subject<void>();

  constructor(
    private polizasService: PolizasService,
    private cotizationService: CotizacionService,
    private store: Store,
    private router: Router,
    private objetosService: ObjetosService,
    private coberturasService: CoberturasService,
    private fraccionPagoService: FraccionamientoService
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectPartner)
      .pipe(takeUntil(this.unsuscribe$))
      .subscribe((res) => {
        if (res) {
          this.queryPolicyList.idEntidad = res.idEntidad;
          this.queryCotizationList.idEntidad = res.idEntidad;

          this.PolicyListOrdered(
            this.queryPolicyList,
            this.queryCotizationList
          );
        }
      });
  }

  select_policy(policy: IContractItem) {
    this.store.dispatch(resetSelectedObject());

    this.store.dispatch(setQuote({ quote: policy.quotation?.data }));

    this.objetosService
      .getObjetsCotizationPolicy({
        idCotizacion: policy.quotation?.data.idCotizacion,
      })
      .pipe(first())
      .subscribe((res) => {
        const object = res.data[0];
        const mapped_object: IObject = {
          id: object.idObjeto,
          descripcion: policy.object.name,
          idTipo: object.idTipoObjeto,
          icono: policy.object.icon,
          selectedProductPrice: policy.quotation.price,
        };

        this.store.dispatch(selectObject({ object: mapped_object }));
      });

    this.fraccionPagoService
      .getFraccionamiento(policy.quotation?.data.idCotizacion)
      .pipe(first())
      .subscribe((res) => {
        const paymentFractions_data = res.data;
        const paymentFractionSelected =
          paymentFractions_data.length > 0 ? paymentFractions_data[0] : null;
        const new_state = {
          list: paymentFractions_data,
          selected: paymentFractionSelected,
        };
        this.store.dispatch(setPaymentFractionState({ new_state: new_state }));
      });

    let dataCoverages: ICoverage[] = [];

    let completeDataPolicy: IPolicyCompleteData = {};

    const idProducto = policy.policy
      ? policy.policy.data.idProducto
      : policy.quotation.data.idProducto;

    this.queryCoberturas = policy.policy
      ? { idCotizacion: policy.policy.data.idCotizacion }
      : { idCotizacion: policy.quotation.data.idCotizacion };

    const coberturas_obligatorias$ =
      this.coberturasService.getCoberturasObligatoriasByIdCotizacion(
        this.queryCoberturas.idCotizacion
      );
    const coberturas_opcionales$ =
      this.coberturasService.getCoberturasOpcionales(
        this.queryCoberturas.idCotizacion
      );

    forkJoin([coberturas_obligatorias$, coberturas_opcionales$])
      .pipe(
        map(([obligatorias, opcionales]) => {
          obligatorias.forEach((x) => (x.mandatory = true));
          opcionales.forEach((x) => (x.mandatory = false));
          return [...obligatorias, ...opcionales];
        })
      )
      .subscribe((resp) => {

        const coverage_infos$ = resp
          // filtramos por seleccionadas
          .filter(coverage => coverage.seleccionada)

          // mapeamos el listado para devolver observables
          .map(coverage => {
            
            // se va a la api, y mapea el resultado de la api (switchMap) SIN EJECUTAR, para añadir el resultado al coverage actual
            return this.getCoverageInfoText(coverage.aliasCobertura, idProducto).pipe(
              first(),
              switchMap(
                (res) => {
                  coverage.details = res;
                  return of(coverage);
                }
              )
            )
          });

        forkJoin(coverage_infos$).subscribe(fork_resp => {

            dataCoverages = [...fork_resp];

            this.objetosService.getObjetsCotizationPolicy(this.queryCoberturas)
              .pipe(first())
              .subscribe((res) => {
                completeDataPolicy.objectData = res.data[0];
                completeDataPolicy.clientData = policy;
                completeDataPolicy.coveragesData = dataCoverages;

                this.store.dispatch(
                  setContract({ contractSelected: completeDataPolicy })
                );
                
                this.router.navigate(['/clientData']);
              });
        })
      });
  }

  // Computed
  get policy_groups(): IPolicyGroupInfo[] {
    const output: IPolicyGroupInfo[] = [];
    this.policies
      .map(x => {
        if(x.status.name === 'Pendiente') {
          x.status.name = 'Pendientes';
        }
        return x;
      })
      .forEach((policy) => {

        let status_group = output.find((x) => x.name === policy.status.name);

        if (!!!status_group) {
          status_group = {
            name: policy.status.name,
            description: policy.status.groupDescription,
            count: 0,
            order: 0
          };
          status_group.order = this.get_order_by_group_name(status_group.name);
          output.push(status_group);
        }
        status_group.count++;
      });

    return output.sort((a, b) => a.order - b.order);
  }

  get_order_by_group_name(group_name: string): number {
    switch(group_name){
      case "Pendientes": return 1;
      case "En espera": return 2;
      case "Aprobados": return 3;
      default: return 99;
    }
  }

  PolicyListOrdered(queryPolicyList, queryCotizationList) {
    const policyList = this.getPolicyList(queryPolicyList).pipe(
      first(),
      switchMap((res) => {
        const listMapped = res.data.map((element) => {
          return {
            dates: {
              start: new Date(element.fechaEstado),
            },
            status: {
              name: 'Aprobados',
              description: element.estado,
              groupDescription: 'Póliza generada correctamente',
            },
            client: {
              fullname: [element.nombre, element.apellido1, element.apellido2]
                .filter((x) => !!x)
                .join(' '),
            },
            object: { icon: element.icono, name: element.categoria },
            quotation: { price: element.primaTotal, data: element },
            policy: { price: element.primaTotal, data: element },
          };
        });

        return of(listMapped);
      })
    );

    const cotizationList = this.getCotizationList(queryCotizationList).pipe(
      first(),
      switchMap((res) => {
        const cotizationList = res.data.map((element) => {
          const estado =
            element.estado === 'En espera'
              ? 'De aprobación de cliente'
              : 'Sin factura asociada';
          return {
            dates: {
              start: new Date(element.fechaEstado),
            },
            status: {
              name: element.estado,
              description: element.estado,
              groupDescription: estado,
            },
            client: {
              fullname: [element.nombre, element.apellido1, element.apellido2]
                .filter((x) => !!x)
                .join(' '),
            },
            object: { icon: element.icono, name: element.categoria },
            quotation: { price: element.primaTotal, data: element },
          };
        });
        return of(cotizationList);
      })
    );

    forkJoin([policyList, cotizationList]).subscribe(
      ([listPolicy, listCotization]) => {

        this.policies = [...listPolicy, ...listCotization]
          .sort(
            (a, b) =>
              new Date(a.dates.start).getTime() -
              new Date(b.dates.start).getTime()
          )
          .reverse()
      }
    );
  }

  getPolicyList(dataQuery?: queryGetPolicyList) {
    const getPolicyList$ = this.polizasService.getPolicyList(dataQuery);

    return getPolicyList$;
  }

  getCotizationList(dataQuery?: queryGetCotizationList) {
    const cotizationService$ =
      this.cotizationService.getCotizationList(dataQuery);

    return cotizationService$;
  }

  fetchCoveragesAsync(cotizacion: IPolicyOrQuotation) {
    const coberturas_obligatorias$ = this.coberturasService
      .getCoberturasObligatoriasByIdCotizacion(cotizacion.idCotizacion)
      .pipe(first());
    const coberturas_opcionales$ = this.coberturasService
      .getCoberturasOpcionales(cotizacion.idCotizacion)
      .pipe(first());

    return forkJoin([coberturas_obligatorias$, coberturas_opcionales$]).pipe(
      map(([obligatorias, opcionales]) => {
        obligatorias.forEach((x) => (x.mandatory = true));
        opcionales.forEach((x) => (x.mandatory = false));
        return [...obligatorias, ...opcionales];
      })
    );
  }

  // Se crea esta funcion SOLO PARA MOCK, no deberia existir.
  // ToDo: Cuadrar con funcional que campo habría que usar de la base de datos en vez de este switch
  getAPICoverageAlias(alias: string) {
    switch (alias) {
      case 'Robo': return 'roboYPerdida';
      case 'Daños materiales': return 'DetCobDaños';
      default:
        return alias;
    }
  }

  getCoverageInfoText(alias: string, idProducto: number) {
    const coverage_alias = this.getAPICoverageAlias(alias);
    return this.objetosService
      .getCoverageInfoText(coverage_alias, idProducto)
      .pipe(
        first(),
        switchMap((resp) => {
          return of(
            resp.data.sort((objectA, objectB) => {
              return (
                objectA.nivel - objectB.nivel || objectA.orden - objectB.orden
              );
            })
          );
        })
      );
  }

  ngOnDestroy(): void {
    this.unsuscribe$.next();
    this.unsuscribe$.complete();
  }
}
